import { useMemo } from 'react';
import type { SimilarDesignItem } from '../../domain/models/SimilarDesignItem';
import { ProductCard } from '@/features/plp/presentation/components/ProductCard';
import type { ListingDesignItem } from '@/features/plp/domain/models/ProductListing';

import { toPriceNumber, formatDisplayPrice } from '@/shared/utils/priceFormatter';

interface SimilarDesignCardProps {
  item: SimilarDesignItem;
  onDesignClick?: (designId: number, designName: string) => void;
}

function mapSimilarDesignItemToListingDesignItem(item: SimilarDesignItem): ListingDesignItem {
  const parsedPrice = item.price != null ? toPriceNumber(item.price) : null;
  const parsedDiscountedPrice = item.discountedPrice != null ? toPriceNumber(item.discountedPrice) : null;

  return {
    designId: item.designId,
    designName: item.designName,
    imageUrl: item.imageUrl,
    productPageUrl: item.productPageUrl ?? '',
    price: parsedPrice !== null ? formatDisplayPrice(parsedPrice) : '₹ 0',
    discountedPrice: parsedDiscountedPrice !== null ? formatDisplayPrice(parsedDiscountedPrice) : undefined,
  };
}

export function SimilarDesignCard({ item, onDesignClick }: SimilarDesignCardProps) {
  const mappedProduct = useMemo(() => mapSimilarDesignItemToListingDesignItem(item), [item]);

  const handleProductClick = () => {
    if (onDesignClick) {
      onDesignClick(item.designId, item.designName);
    }
  };

  return (
    <ProductCard
      product={mappedProduct}
      className="rounded-[5px] border border-gray-200 bg-white"
      onProductClick={handleProductClick}
      hideVideoCallButton
      hideViewDetailsButton
    />
  );
}
